export default {
  sideMenu: {
    admin: 'Admin',
    brands: 'Brands',
    consumers: 'Consumidores',
    dispatch: 'Envío',
    laxit: 'LAXit',
    promo: 'Promoción',
    providers: 'Providers',
    providerDeductions: 'Provider Deductions',
    providerPayouts: 'Provider Payouts',
    geofences: 'Geofences',
    routing: 'Enrutamiento',
    reports: 'Informes',
    transactions: 'Actas',
    marketingAds: 'Marketing Ads',
    filters: 'Filters',
    settings: 'Settings',
    serviceTypes: 'Tipos de servicio',
    pricing: 'Precios'
  },
  login: {
    ctaDefault: 'INICIAR',
    ctaLoading: 'INICIAR SESIÓN...',
    inputEmail: 'Email',
    inputPassword: 'Contraseña',
    forgotLink: 'Se te olvidó tu contraseña?',
    errorLogin: 'Combinación inválida de correo electrónico/contraseña.'
  },
  consumer: {
    loading: 'Obteniendo ofertas...',
    tabLabel: {
      referrals: 'Referencias',
      transactions: 'Actas',
      bids: 'Ofertas',
      ratings: 'Calificaciones',
      creditCard: 'Tarjeta de crédito',
      promoCodes: 'Códigos promocionales'
    },
    call: 'Llama ',
    personalInfo: {
      label: 'Informacion personal',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil'
    },
    accountInfo: {
      label: 'Información de la cuenta',
      created: 'Cuenta creada',
      referralCode: 'código de referencia',
      numberOfReferral: 'Número de referencia'
    },
    referrals: {
      search: 'Buscar',
      export: 'Exportar',
      id: 'ID',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil',
      accountCreatedDate: 'Fecha de creación de la cuenta',
      lastTrx: 'Ultima TRX Cita',
      totalTrx: 'Total TRX',
      avgRating: 'Puntuación media',
      referralCode: 'Código de referencia',
      totalReferral: 'Referencias totales',
      emptyState: 'Sin referencias hasta el momento.'
    },
    transactions: {
      search: 'Buscar',
      from: 'De',
      to: 'A',
      export: 'Exportar',
      date: 'Fecha',
      providerId: 'Proveedor ID',
      company: 'Empresa',
      rsvpId: 'RSVP ID',
      invoiceId: 'Factura ID',
      type: 'Tipo',
      guestFirstName: 'Nombre del huésped',
      guestLastName: 'Apellido del invitado',
      mobile: 'Móvil',
      creditCard: 'Tarjeta de crédito',
      bookedThrough: 'Libro a través',
      finalOffer: 'Oferta final',
      chargedAmount: 'Cantidad cobrada',
      promoUsed: 'Promoción utilizada',
      status: 'Estado',
      loading: 'Obtener transacciones...',
      emptyState: 'No hay transacciones hasta el momento.'
    },
    ratings: {
      export: 'Exportar',
      date: 'Fecha',
      rsvpId: 'Reserva ID',
      provBusinessName: 'Nombre comercial del proveedor',
      rating: 'Clasificación',
      msg: 'Mensaje',
      loading: 'Obteniendo los comentarios que enviaste...',
      emptyState: 'Sin calificaciones hasta el momento.'
    },
    creditCards: {
      export: 'Exportar',
      addedOn: 'Añadido',
      creditCard: 'Tarjeta de crédito #',
      address: 'Dirección de Envio',
      city: 'Billing City',
      state: 'Estado de cuenta',
      zip: 'Facturación Zip',
      status: 'Estado',
      loading: 'Obtener sus tarjetas de crédito...',
      emptyState: 'No hay tarjetas de crédito hasta el momento.'
    },
    promoCodes: {
      date: 'Fecha de canje',
      code: 'Código promocional',
      value: 'Valor',
      type: 'Tipo',
      expires: 'Vence',
      amountUsed: 'Cantidad usada',
      loading: 'Obteniendo tus códigos promocionales...',
      emptyState: 'No hay códigos promocionales aún.'
    },
    save: 'Salvar',
    saving: 'Ahorro...',
    sendResetPassword: 'Enviar Restablecer Password',
    sending: 'Enviando...',
    passwordSent: 'Éxito! Contraseña enviada!',
    formSuccessful: 'El perfil del consumidor se ha actualizado con éxito.',
    emptyField: 'Este campo no puede estar vacío.',
    list: {
      heading: 'Lista de consumidores',
      reactivate: 'Reactivar',
      disable: 'Disable',
      update: 'inhabilitar',
      confirmLabel: 'Seguro que quieres {action} usuario (s) seleccionado (s)?',
      yesUpdate: 'Sí, actualizar usuarios seleccionados',
      statusUpdateLoading: 'Estado de actualización...',
      statusUpdateSuccess: 'Estado actualización éxito!',
      errorMsg: 'Oops! Algo salió mal.',
      close: 'Cerca',
      sendNotif: 'Enviar notificación',
      pushNotif: 'Notificación de inserción',
      target: 'Objetivo',
      zeroSelected: 'Seleccione usuario (s) de la lista',
      allUser: 'Todos los usuarios',
      selectedUser: 'Usuario Seleccionado',
      brands: 'Marcas',
      emptyBrand: 'Por favor seleccione qué marca desea enviar notificación (es).',
      title: 'Título',
      message: 'Mensaje',
      charLeft: '{count} Personaje (s) dejado (s)',
      img: 'Imagen',
      send: 'Enviar',
      cancel: 'Cancelar',
      sendingNotif: 'Envío de notificaciones...',
      sendNotifSuccess: 'Enviar notificación de éxito!',
      selectImgFile: 'Seleccione un archivo de imagen.',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      email: 'Email',
      mobile: 'Móvil',
      created: 'Fecha de creación',
      lastTrx: 'Última fecha TRX',
      totalTrx: 'Número total de TRX',
      referralCode: 'Código de referencia',
      referralCount: 'Número de referencias',
      referrals: 'Referencias',
      details: 'Detalles',
      status: 'Estado',
      gettingUsers: 'Obtener usuarios...'
    }
  },
  dispatch: {
    driverCall: 'LLAME A {driverName}',
    driverSend: 'ENVIAR A {driverName}',
    driverAssign: 'ASIGNAR A {driverName}',
    title: 'ENVÍO',
    rsvpSearchPlaceholder: 'Escriba y presione enter para buscar.',
    filterPlaceholder: 'Seleccione un filtro.',
    openMap: 'MAPA ABIERTO',
    rsvpTable: {
      id: 'ID',
      status: 'ESTADO',
      pickup: 'RECOGER',
      dropoff: 'DESTINO',
      pickupTime: 'HORA DE RECOGIDA',
      customer: 'CLIENTE',
      driver: 'CONDUCTOR',
      serviceType: 'TIPO DE SERVICIO',
      pickupType: 'TIPO DE RECOGIDA',
      flight: 'VUELO',
      ada: 'ADA',
      pax: 'PASAJERO/<br/>EQUIPAJE/<br/>PARE',
      emptyRsvp: {
        title: 'Use el formulario en la parte superior.',
        content: 'Para comenzar, seleccione un filtro o busque una reserva o paquete usando el formulario en la parte superior de la página.'
      },
      loadingData: {
        title: 'Cargando Reservas',
        content: 'Agárrate fuerte! Esto será rápido.'
      },
      noData: {
        title: 'Oops. Parece que no encontramos nada.',
        content: 'No podemos encontrar ninguna reserva o paquete para ese filtro. Utilice otro del formulario en la parte superior.'
      }
    },
    driverTable: {
      id: 'ID',
      name: 'NOMBRE',
      services: 'SERVICIOS',
      pax: 'PASAJERO',
      license: 'LICENCIA',
      status: 'ESTADO',
      phone: 'TELÉFONO',
      loading: {
        title: 'Buscando conductores',
        content: '¡Estarse quieto! Estamos buscando conductores.'
      },
      empty: {
        title: '¡Oh no! Nadie está en línea',
        content: 'Parece que no hay controladores disponibles en este momento.'
      }
    },
    mapDetails: {
      package: 'Paquete',
      reservation: 'Reserva',
      packagePickup: 'PRIMERO DIRECCIÓN DE ENTREGA',
      packageDropoff: 'ÚLTIMO DIRECCIÓN DE DESTINO',
      pickup: 'DIRECCIÓN DE ENTREGA',
      dropoff: 'DIRECCIÓN DE DESTINO',
      pickupTime: 'HORA DE RECOGIDA',
      flight: 'INFORMACION DE VUELO',
      paxLuggageStops: 'PASAJERO/EQUIPAJE/PARE',
      paxLuggage: 'PASAJERO/EQUIPAJE',
      serviceType: 'TIPO DE SERVICIO',
      status: 'ESTADO',
      paxName: 'NOMBRE DEL PASAJERO',
      paxEmail: 'EMAIL DEL PASAJERO',
      paxPhone: 'TELÉFONO DEL PASAJERO',
      paxNote: 'NOTA DEL PASAJERO',
      guestInfo: 'INFORMACION DEL INVITADO',
      guestName: 'NOMBRE DEL INVITADO',
      guestPhone: 'TELÉFONO DEL INVITADO',
      guestNone: 'No hay información de invitado para esta reserva',
      guestAdd: 'ADD GUEST INFORMACION',
      driverName: 'NOMBRE DEL CONDUCTOR',
      driverPhone: 'TELÉFONO DEL CONDUCTOR',
      driverEmail: 'EMAIL DEL CONDUCTOR',
      driverInfo: 'INFORMACIÓN DEL CONDUCTOR',
      packageDriverNone: 'No hay conductor todavía para esta paquete.',
      driverNone: 'No hay conductor todavía para esta reserva.',
      emptyTitle: 'No tengo nada para mostrar en este momento.',
      emptyContent: 'Para comenzar, seleccione una reserva/paquete de la <a href="/es/#/dispatch/reservations" target="_blank">lista</a>.'
    },
    map: {
      filterControls: {
        title: 'Use esto para buscar controladores.',
        labelRadius: 'BUSCAR RADIO (EN MILLAS):',
        labelServices: 'TIPOS DE SERVICIO INCLUIDOS:',
        labelButton: 'ENCUENTRA CONDUCTORES',
        labelLoading: 'Encontrar Conductores...'
      }
    }
  },
  provider: {
    tabLabel: {
      accountDetails: 'Account',
      services: 'Servicios',
      payout: 'Payouts',
      statistics: 'Estadística',
      availability: 'Availability',
      shift: 'Shifts',
      reviews: 'Comentarios',
      notes: 'Notas',
      upcoming: 'Próximo',
      completed: 'Terminado',
      payout: 'Payouts'
    },
    active: 'Activo',
    deactive: 'Desactivar',
    modal: {
      toActivate: 'Seguro que quieres activar <b>{provider}</b>?',
      toDeactivate: 'Estás seguro de que quieres desactivar <b>{provider}</b>?',
      no: 'No',
      yes: 'Yes'
    },
    call: 'Llama ',
    enableServices: 'Servicios habilitados',
    backgroundSubmitted: 'Verificación de antecedentes enviada',
    backgroundPassed: 'Verificación de antecedentes pasada',
    maxRsvp: 'Max reservas diarias',
    default: 'Defecto',
    custom: 'Personalizado',
    basicInfo: {
      label: 'Información básica',
      firstName: 'Nombre de pila',
      lastName: 'Apellido',
      deviceOS: 'Sistema operativo del dispositivo',
      deviceModel: 'Modelo de dispositivo',
      email: 'Dirección de correo electrónico',
      language: 'Idioma',
      mobile: 'Teléfono',
      birthday: 'Cumpleaños',
      resetPassword: 'Restablecer la contraseña',
      password: 'Contraseña',
      repassword: 'Repite la contraseña'
    },
    vehicleInfo: {
      label: 'Información del vehículo',
      type: 'Tipo de vehiculo',
      year: 'Año',
      capacity: 'Capacidad',
      boxCapacity: 'Box Capacidad',
      door: 'Puerta',
      manufacturer: 'Fabricante',
      model: 'Modelo',
      identificationNumber: 'Número de identificación del vehículo',
      licensePlate: 'Placa',
      wheelchair: 'Equipado con elevador de silla de ruedas.',
      serviceDog: 'Puede acomodar un perro de servicio.'
    },
    accountType: {
      label: 'Tipo de cuenta',
      tcpPermit: 'Ya tienes un TCP (Transportation Charter Permit) Permiso?',
      type: 'Anular el tipo de cuenta'
    },
    businessInfo: {
      label: 'Información de negocios',
      name: 'Nombre del Negocio',
      city: 'Ciudad',
      address1: 'Dirección',
      address2: 'Dirección 2',
      country: 'País',
      state: 'Estado',
      zip: 'cremallera',
      type: 'Tipo de negocio'
    },
    documentation: {
      label: 'Documentación',
      insuranceCompany: 'Nombre de la compañía de seguros',
      insurancePolicy: 'Póliza de seguros #',
      insuranceExp: 'fecha de caducidad',
      cityLicense: 'Licencia de ciudad #',
      cityLicenseExp: 'fecha de caducidad',
      tcpPermit: 'TCP Permiso #',
      tcpPermitExp: 'fecha de caducidad',
      airportPermit: 'Permiso de aeropuerto #',
      airportPermitExp: 'fecha de caducidad',
      driversLicense: 'Licencia de conducir #',
      driversLicenseExp: 'fecha de caducidad',
      vehicleInspection: 'Inspección de seguridad del vehículo realizada por',
      vehicleInspectionExp: 'fecha de caducidad',
      drivingRecord: 'Verificación de antecedentes del conductor',
      drivingRecordExp: 'Fecha de caducidad'
    },
    eligibility: {
      label: 'Elegibilidad',
      convicted: 'Ha sido condenado, en los últimos 7 años, por manejar bajo la influencia de drogas o alcohol, fraude, delitos sexuales, uso de un vehículo de motor para cometer un delito grave, un delito que involucra daños a la propiedad y / o robo, actos de violencia, o actos de terror?',
      conviction: 'Alguna vez ha tenido una condena por conducir imprudentemente, conducir bajo la influencia, golpear y correr o conducir con una licencia suspendida o revocada?',
      ownVehicle: 'Eres el propietario de este vehículo?',
      modifiedVehicle: 'Alguna vez este vehículo ha sido modificado significativamente de las especificaciones de fábrica (por ejemplo, "vehículo elástico", no legalizado en la calle, etc.)?',
      driversLicense: 'Ha tenido su licencia de conducir por al menos 2 años?'
    },
    agreements: {
      label: 'Acuerdos',
      declarePenalty: 'Declaro bajo pena de perjurio bajo las leyes del Estado de California que soy el conductor que figura en esta solicitud, toda la información aquí proporcionada es verdadera y correcta.',
      agree: 'Acepto cumplir con las Reglas de Conducta del Conductor de Prime Time Rideshare ({conductRules}) así como los términos de uso ({terms}) y política de privacidad ({privacy}). Entiendo que mi incumplimiento de ellos puede dar como resultado la terminación de mi asociación con Prime Time Rideshare. Entiendo que Prime Time Rideshare no es un transportista sino una herramienta para conectar a conductores y pasajeros.',
      signature: 'Firma'
    },
    save: 'Salvar',
    saving: 'Ahorro...',
    close: 'Cerca',
    cancel: 'Cancelar',
    addNotes: 'Agregar notas',
    statistics: {
      export: 'Estadísticas de exportación',
      dateRange: 'Seleccionar rango de fechas',
      hours: 'Horas de servicio',
      bids: 'Ofertas hechas',
      rsvpComplete: 'Reservaciones completadas',
      rsvpCancelledProv: 'Reservaciones canceladas por el proveedor',
      rsvpCancelledCon: 'Reservas canceladas por el consumidor',
      earned: 'Monto ganado'
    },
    reviews: {
      average: 'Revisión promedio',
      fiveStar: 'Reseñas de 5 estrellas',
      total: 'Reseñas totales',
      date: 'Fecha',
      name: 'Nombre',
      message: 'Mensaje',
      rating: 'Clasificación',
      loading: 'Obtener revisiones...',
      emptyState: 'No hay comentarios hasta el momento...'
    },
    notes: {
      loading: 'Obteniendo notas...',
      emptyState: 'No hay notas hasta el momento.',
      name: 'Nombre',
      date: 'Fecha',
      message: 'Mensaje',
      status: 'Estado',
      edit: 'Editar',
      delete: 'Borrar'
    },
    provReservation: '{provider}\'s Reservas',
    reservations: {
      from: 'de',
      to: 'a',
      id: 'ID',
      pickupTime: 'Hora de recogida',
      pickup: 'Recoger',
      dropoff: 'Drop-off',
      service: 'Servicio',
      customer: 'Cliente',
      paxLuggage: 'PAX / Equipaje',
      flight: 'Vuelo',
      loading: 'Obtener reservas...',
      driverPayment: 'Pago del conductor',
      totalDriverPayment: 'Pago total del conductor',
      emptyState: {
        upcoming: 'No hay próxima reserva aún.',
        history: 'No hay reserva completada hasta el momento.'
      }
    },
    formSuccessful: 'El perfil del conductor se ha actualizado con éxito.',
    formFail: 'Error al actualizar el perfil del conductor.',
    emptyField: 'Este campo no puede estar vacío.',
    invalidEmail: 'Formato de correo inválido.',
    emptyServices: 'Se debe elegir al menos un tipo de servicio para este proveedor de transporte antes de poder guardar sus cambios.',
    sendEmailLabel: 'Envíe un enlace de restablecimiento de contraseña a este proveedor.',
    sendToEmail: 'Enviar al correo electrónico',
    sending: 'Enviando...',
    orTypeIn: 'O TIPO DE ENTRADA',
    passwordNotMatch: 'La contraseña y la contraseña de repetición no coinciden.',
    passwordSuccess: 'Éxito! La contraseña del conductor ha sido cambiada!',
    passwordSent: 'Éxito! Contraseña enviada!',
    upload: 'Subir',
    uploading: 'Cargando...',
    uploadError: 'Oops! Algo salió mal. Inténtalo de nuevo.',
    documenationNotice: 'Adjunte imágenes escaneadas o fotografiadas de sus documentos a continuación. <br />Asegúrese de que los tipos de archivos que se cargan tengan uno de los siguientes formatos: <i><b>PDF, JPEG, JPG, GIF, PNG</b></i>.'
  },
  rsvpDetails: {
    rsvpId: 'Reserva {id}',
    tabLabel: {
      basicInfo: 'Informacion basica',
      transactions: 'Actas',
      notes: 'notas',
      activityLogs: 'Registros de actividad',
      systemLogs: 'Registros del sistema'
    },
    tripInformation: {
      label: 'Información de viaje',
      brand: 'Marca',
      bookedThrough: 'Fuente',
      createdOn: 'Creado en',
      pickupDate: 'Fecha de recogida',
      driverPayment: 'Pago del conductor',
      seePaymentBreakdown: 'Ver el desglose del pago',
      paymentBreakdown: 'Desglose de pago',
      fareAmount: 'Tarifa de tarifa',
      bonus: 'Prima',
      pickupType: 'Tipo de pastilla',
      tip: 'Propina',
      airportFee: 'Tarifa de aeropuerto',
      pickupFee: 'Tasa De Recogida',
      close: 'Cerca',
      fare: 'Tarifa',
      serviceType: 'Tipo de servicio',
      pickup: 'Lugar de recogida',
      dropoff: 'Punto de entrega',
      beThereTime: 'Tómese tiempo',
      distance: 'Distancia',
      flightInfo: 'Informacion de vuelo',
      terminal: 'Terminal',
      passenger: 'Pasajero',
      luggage: 'Equipaje',
      notes: 'Notas',
      serviceName: 'Área de servicio',
      rating: 'Clasificación',
      userReview: 'Revisión del usuario'
    },
    customerInformation: {
      label: 'Informacion al cliente',
      name: 'Nombre',
      id: 'Id',
      paidWith: 'Pagado con',
      email: 'Direccion de correo electronico',
      mobile: 'Telefono movil'
    },
    guestInformation: {
      label: 'Informacion del Invitado',
      name: 'Nombre',
      mobile: 'Telefono movil',
      emptyState: 'Esto no fue reservado para un invitado.',
      addBtn: 'Agregar información del huésped'
    },
    driverInformation: {
      label: 'Información del conductor',
      name: 'Nombre',
      id: 'Id',
      avgRating: 'Puntuación media',
      driversLicense: 'Licencia de conducir',
      make: 'Hacer',
      model: 'Modelo',
      licensePlate: 'Placa',
      mobile: 'Telefono movil',
      email: 'Email',
      emptyState: 'No hay conductor para esta reserva.',
      findBtn: 'Encuentra un conductor',
      releaseBtn: 'Release Driver'
    },
    transactions: {
      dateTime: 'Fecha',
      invoiceId: 'Factura ID',
      card: 'Tarjeta',
      finalOffer: 'Oferta Final',
      chargedAmount: 'Cantidad cobrada',
      cancelFee: 'Cancelar tarifa',
      bonus: 'Prima',
      promoUsed: 'Promoción utilizada',
      status: 'Estado'
    },
    notes: {
      loading: 'Obteniendo notas...',
      emptyState: 'No hay notas todavia.',
      edit: 'Editar',
      delete: 'Borrar',
      deleteMessage: 'Estás seguro que quieres eliminar esta nota?',
      no: 'No',
      yes: 'Sí'
    },
    history: 'Historia',
    activityLogs: {
      emptyState: 'Aun no hay registros de actividad.',
      dateTime: 'Fecha',
      activity: 'Actividad',
      placeholder: '<b>{author}</b> hizo una actualización el último <b>{date}</b> al <b>{time}</b>'
    },
    systemLogs: {
      emptyState: 'No hay registros del sistema todavia.'
    },
    cancelRsvp: 'Cancelar esta reserva',
    sendRefund: 'Enviar reembolso',
    markComplete: 'Marcar como completo',
    addNote: 'Agregar una nueva nota',
    sendConfirmationEmail: 'Enviar correo electronico de confirmacion',
    sendReceiptEmail: 'Enviar correo electrónico de recibo',
    sendCancellationEmail: 'Enviar correo electrónico de cancelación',
    editRsvp: 'Editar esta reserva',
    cancelEdit: 'Cancelar editar',
    saveChanges: 'Guardar cambios',
    flightStatus: {
      loading: 'Actualización del estado del vuelo...',
      error: 'Algo salió mal de nuestro lado. Inténtalo de nuevo.',
      status: 'Estado',
      departureAirport: 'Aeropuerto de salida',
      arrivalAirport: 'Aeropuerto de llegada',
      arrivalDate: 'Fecha de llegada',
      departureDate: 'Fecha de salida',
      tryAgain: 'Inténtalo de nuevo'
    },
    sending: 'Enviando...',
    close: 'Cerca',
    emailSent: 'Email enviado.',
    cancelSuccess: '<b>Reserva {rsvpid}</b> cancelada exitosamente',
    edit: {
      rideRetails: 'Detalles de viaje',
      customerInfo: 'Información al cliente',
      aptGate: 'Apartamento # / portón #',
      airline: 'Aerolínea',
      flight: 'Vuelo',
      wheelchair: 'Silla de ruedas',
      serviceDog: 'Perro de servicio',
      services: 'Servicios',
      priceOverride: {
        label: 'Price Override',
        desc: 'Esto anulará el precio total del viaje, incluida la tarifa del tipo de recogida.'
      },
      driverOverride: {
        label: 'Anular el pago del conductor',
        desc: 'Esto anulará el pago para el proveedor excluyendo el tipo de tarifa de recolección.'
      },
      bookingForSomeone: 'Reserve esta reservación para otra persona.',
      guestFirstName: 'Nombre del huésped',
      guestLastName: 'Apellido del huésped',
      guestMobile: 'Móvil del invitado',
      driverNotes: 'Nota para el conductor',
      paymentSummary: 'Resumen de pago',
      fare: 'Tarifa',
      airportFee: 'Tarifa de aeropuerto',
      tip: 'Propina',
      total: 'Total',
      complimentary: 'Complementario',
      curbside: 'Acera (gratis)',
      meetAndGreet: 'Meet & Greet',
      priceChange: 'Sus ediciones han cambiado el precio de esta reserva, asegúrese de informar al cliente de la actualización del precio.',
      totalFareChange: 'Cambio de tarifa total desde',
      updateSuccessMsg: '<b>Reserva {id}</b> actualizada con éxito',
      updatingReservation: 'Actualización de reserva...',
      emptyField: 'Este campo no puede estar vacío.',
      adminTimeBufferError: 'El tiempo de envío debe ser mayor a {min} minutos desde la hora actual.',
      selectError: 'Seleccione de la lista.',
      selectService: 'Seleccione un servicio para esta reserva.',
      serviceRestrictions: 'Ciertos servicios no están disponibles debido a restricciones del área de servicio.',
      zeroValue: 'El valor no puede ser menor o igual a cero.'
    }
  },
  rsvpNotes: {
    title: {
      regular: 'Por favor deja una nota.',
      refund: 'Reserva de reembolso',
      confirmRefund: 'Confirmar reembolso',
      noShowRefund: 'Confirmar No Show Refund'
    },
    payCancellationFee: 'El cliente deberá pagar una tarifa de cancelación de <b> {amount} </ b>. ¿Quieres cobrar la tarifa de cancelación?',
    yes: 'Sí',
    no: 'No',
    refundType: 'Tipo de reembolso',
    fullRefund: 'Reembolso completo',
    partialRefund: 'Reembolso parcial',
    issueCredit: 'Emitir crédito',
    additionalCharge: 'Cargos adicionales',
    refundAmountEmpty: 'El campo no puede estar vacío.',
    notNumber: 'Número invalido.',
    lowNumber: 'No puede ser menor o igual a cero.',
    close: 'Cerca',
    notes: 'Notas',
    emptyNotes: 'Por favor ponga una nota en el cuadro de texto.',
    charLeft: '{value} Personaje(s) dejado.',
    status: 'Estado',
    new: 'NUEVO',
    investigation: 'INVESTIGACIÓN',
    resolved: 'RESUELTO',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    successCredit: 'Emitió crédito exitosamente!'
  },
  transactions: {
    title: 'Actas',
    gross: 'Ingresos brutos',
    ofDateRange: 'del rango de fechas',
    creditUsed: 'Crédito utilizado',
    onlineProv: 'Proveedores en línea',
    filter: {
      search: 'Buscar',
      searchEmpty: 'Seleccionar "Todo" del rango de fechas requiere buscar palabra clave.',
      status: 'Estado',
      dateRange: 'Rango de fechas',
      all: 'Todas',
      custom: 'Personalizado',
      declined: 'Rechazado',
      cancelled: 'Cancelado',
      promo: 'Promoción',
      purchased: 'Comprado',
      authorized: 'Autorizado',
      noShow: 'No Show',
      completed: 'Terminado',
      refund: 'Reembolso',
      edited: 'Editado',
      withinDay: 'En un día',
      monthToDate: 'Mes hasta la fecha',
      lastMonth: 'El mes pasado',
      lastWeek: 'La semana pasada',
      last2Week: 'Las últimas 2 semanas',
      last30Days: 'Últimos 30 días',
      last60Days: 'Últimos 60 días',
      last90Days: 'Últimos 90 días',
      from: 'De',
      to: 'A',
      invalidDateRange: 'Rango de fecha no válido.',
      emptyDate: 'El campo no puede estar vacío.',
      refresh: 'Refrescar',
      export: 'Exportar'
    },
    list: {
      date: 'Fecha',
      serviceArea: 'Área de servicio',
      company: 'Empresa',
      invoiceId: 'Factura ID',
      rsvpId: 'RSVP ID',
      pickup: 'Recoger',
      dropoff: 'Dropoff',
      type: 'Tipo',
      service: 'Servicio',
      customerName: 'Nombre del cliente',
      email: 'Email',
      mobile: 'Móvil',
      creditCard: 'Tarjeta de crédito',
      source: 'Fuente',
      finalOffer: 'Oferta final',
      chargedAmount: 'Cantidad cobrada',
      bonus: 'Prima',
      promoUsed: 'Promoción utilizada',
      cancelFee: 'Cancelar tarifa',
      status: 'Estado',
      loading: 'Obteniendo Transacciones...',
      empty: 'Ningún record fue encontrado!',
      display: 'Monitor',
      resultsPerPage: 'resultados por página.',
      displaying: 'Mostrando {min} - {max} de {total}'
    },
    unableToRefund: 'No se puede reembolsar',
    otherMeans: 'Esta transacción se pagó a través de medios que no sean una tarjeta de crédito. No puede ser reembolsado automáticamente a través del sistema. Por favor cancele la reserva a través de la página Editar RSVP.',
    close: 'Cerca'
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js